import React from 'react';
import PropTypes from 'prop-types';
import MealItem from '../../common/MealItem';

const OrderCartItemGrid = (props) => {

    // Helper function to extract specs from productSpec - group options by spec group
    const extractSpecs = (productSpecItem) => {
        if (!productSpecItem || !productSpecItem.spec) return [];

        return productSpecItem.spec.map(specGroup => {
            const selectedOptions = specGroup.specOptions?.filter(opt => opt.selected) || [];
            const optionNames = selectedOptions.map(opt =>
                opt.specPrice > 0 ? `${opt.specName} +$${opt.specPrice}` : opt.specName
            );
            return optionNames.join(', '); // Join multiple options with comma
        }).filter(line => line.length > 0); // Remove empty lines
    };

    // Helper function to extract simple options
    const extractSimpleOptions = (simpleOptions) => {
        if (!simpleOptions) return [];
        return simpleOptions.map(opt => opt.name || opt);
    };

    if (props.orderDetail.hasMenuSpec === 'true'){
        return (
            <React.Fragment>
                {
                    props.orderDetail.productSpec.map(
                        (productSpecItem, idx) => {
                            return (
                                <div key={`${productSpecItem}_${idx}`}>
                                    <MealItem
                                        itemName={props.orderDetail.name}
                                        specs={extractSpecs(productSpecItem)}
                                        simpleOptions={extractSimpleOptions(props.orderDetail.simpleOptions)}
                                        quantity={productSpecItem.qty}
                                        unitPrice={productSpecItem.priceForOne}
                                        productIdx={props.idx}
                                        specIdx={idx}
                                    />
                                </div>
                            )
                        }
                    )
                }
            </React.Fragment>
        )
    } else {
        return (
            <div>
                <MealItem
                    itemName={props.orderDetail.name}
                    simpleOptions={extractSimpleOptions(props.orderDetail.simpleOptions)}
                    quantity={props.orderDetail.qty}
                    unitPrice={props.orderDetail.price}
                    productIdx={props.idx}
                />
            </div>
        )
    }
};

OrderCartItemGrid.propTypes = {
    orderDetail: PropTypes.object.isRequired,
    idx: PropTypes.number.isRequired,
};

export default OrderCartItemGrid;